/**
 *  更新state状态
 * */
export enum UPDATE_STATE_TYPE {
    PRE_INFO = 'PRE_INFO', // 使用平台资料
    BASE_INFO = 'BASE_INFO', // 使用基础资料  基础资料使用此状态表示加载完成
    HAS_EDITED = 'HAS_EDITED' // 编辑过
}

/**
 *  页面表单状态
 * */
export enum FORM_TYPE {
    CREATE = 'create', // 创建
    EDIT = 'edit', // 编辑
    PERFECT = 'perfect', // 完善
    COPY = 'copy' // 复制
}

/**
 *  日志查看
 * */
export const GYL_LOG_LOOK = 'LOG_LOOK'

export const FIXED_VALUE = 'FIXED_VALUE'
export const RULE_VALUE = 'RULE_VALUE'

export const VALUE_TYPES = [
    {
        value: FIXED_VALUE,
        label: '固定日期'
    },
    {
        value: RULE_VALUE,
        label: '规则日期'
    }
]

// 生产日期 需要特殊处理
export const PRODUCTION_DATE = 'PRODUCTION_DATE'
